import { cn } from '@/shared/lib/utils';

import './chrome.css';

interface AmbientGlowProps {
  level?: 'rest' | 'active';
}

export default function AmbientGlow({ level = 'rest' }: AmbientGlowProps) {
  return <div className={cn('ob-glow', level === 'active' && 'ob-glow--active')} aria-hidden="true" data-testid="onboarding-ambient-glow" />;
}
